module.exports = __webpack_public_path__ + "static/media/03.284256e9.png";